import { IApplicationState } from '../../types/redux';

export function getPriceForObjectFromDeveloperDisplay(state: IApplicationState) {
  const {
    newbuilding: { priceForObjectFromDeveloperDisplay },
  } = state;

  return priceForObjectFromDeveloperDisplay;
}
